import React from "react";
import HoverFlag from "MODULES/parts/components/HoverFlag";

const ModifiedFlag = () => <HoverFlag text="Modified" />;

export default ModifiedFlag;



// WEBPACK FOOTER //
// ./app/modules/parts/components/ModifiedFlag/ModifiedFlag.jsx